import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useState } from "react";

import { DatePicker } from "antd";
import Loading from "../../loader/loader.js";
import NkHeader from "../../../common/nkheader.js";
import NkTable from "../nktable.js";
import moment from "moment";

const RegistrationPresentational = ({
  searchBy,
  setSearchByValue,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,
  fromDate,
  toDate,

  setToDate,
  setModalShow,
  filtersSelected,
  noOfFiltersSelected,
  resetFilter,
  handleFIlter,
  filterValues,
  allUserList,
  dataLoading,
  pagination,
  allUserListExcel,
  buttonRef,
  csvLink,
  onExcelClciked,
  filterForm,
  columns,
  columnsCsv,
  setSizeShow,
  setFilterForm,
  setFromDate,
  rowOnClick,
  kyc,
  showError,
  setShowError,
}) => {
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  // const [searchByValue, setSearchByValue] = useState("");
  const getErrMessage = () => {
    if (kyc === "NoKYC" && searchBy === "mobile") {
      return "Valid phone number is required";
    } else {
      return "Min three characters required";
    }
  };
  return (
    <Container fluid>
      <NkHeader title="Verifications" />
      <Card>
        <CardBody>
          <Row>
            <Col lg="2" className="form-input-padding">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="exampleFormControlSelect1"
                >
                  Search by
                </label>
                <Input
                  id="exampleFormControlSelect1"
                  style={{ height: "27px" }}
                  type="select"
                  value={searchBy}
                  onChange={(e) => {
                    // e.preventDefault();
                    if (e.target.value.length >= 3) {
                      setShowError(false);
                    }
                    setSearchByValue("");
                    setSearchBy(e.target.value);
                  }}
                >
                  <option value="mobile">Mobile</option>
                  <option value="name">Name</option>
                  <option value="ctid">CT ID</option>
                  <option value="branchId">Branch ID</option>
                  <option value="emiratesId">Emirates ID</option>
                  <option value="cardSerialNumber">Card Serial</option>
                </Input>
              </FormGroup>
            </Col>
            <Col lg="2" className="form-input-padding">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  Search for
                </label>
                <Input
                  id="example3cols2Input"
                  className={
                    showError && searchByValue.length < 3
                      ? "search-for-boxstyle-error"
                      : ""
                  }
                  style={{ height: "27px" }}
                  placeholder={searchByValuePlaceholder}
                  onKeyPress={(e) =>
                    e.charCode === 13 && handleFIlter(searchByValue)
                  }
                  type="text"
                  onChange={(e) => {
                    // e.preventDefault();
                    setSearchByValue(e.target.value && e.target.value);
                  }}
                  value={searchByValue}
                />
                <p className="searchfor-error-message">
                  {showError && searchByValue.length < 3 ? getErrMessage() : ""}
                </p>
              </FormGroup>
            </Col>
            <Col lg="2" className="form-input-padding">
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  From
                </Label>
                <DatePicker
                  format={customFormat}
                  placeholder="DD-MM-YY"
                  className="formcontrol-date"
                  onChange={(e, dateString) => {
                    if (dateString && dateString != "") {
                      setFromDate(moment(dateString, dateFormat));
                    } else {
                      setFromDate(null);
                    }
                  }}
                  value={fromDate}
                  // format={dateFormat}
                />
              </FormGroup>
            </Col>
            <Col lg="2" className="form-input-padding">
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  To
                </Label>
                <DatePicker
                  format={customFormat}
                  placeholder="DD-MM-YY"
                  className="formcontrol-date"
                  onChange={(e, dateString) => {
                    if (dateString && dateString != "") {
                      setToDate(moment(dateString, dateFormat));
                    } else {
                      setToDate(null);
                    }
                  }}
                  value={toDate}
                  // format={dateFormat}
                />
              </FormGroup>
            </Col>
            <div
              lg="1"
              className="form-input-padding"
              style={{ marginTop: "2px" }}
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="exampleFormControlSelect1"
                >
                  Filter by
                </Label>
                <div>
                  <Button
                    style={{ width: "100%", height: "26px" }}
                    color="primary"
                    type="button"
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => setModalShow(true)}
                  >
                    <div>
                      <i class="fas fa-filter"></i>
                    </div>
                  </Button>
                </div>
              </FormGroup>

              <span style={{ fontSize: 8 }}>
                {filtersSelected && noOfFiltersSelected > 0 ? (
                  <>
                    <h6 style={{ display: "flex", alignItems: "center" }}>
                      Selected({noOfFiltersSelected})
                      {kyc !== "FullKYC" ? (
                        <i
                          class="fas fa-window-close"
                          style={{ cursor: "pointer", paddingLeft: "5px" }}
                          onClick={() => {
                            setSearchByValue("");
                            resetFilter();
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </h6>
                  </>
                ) : (
                  <></>
                )}
              </span>
            </div>
            <Col
              lg="1"
              style={{ marginTop: "9px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Button
                    type="button"
                    style={{
                      width: "100%",
                      background: "#e91d24",
                      color: "white",
                      height: "26px",
                      border: "1px solid rgb(233, 29, 36)",
                    }}
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => handleFIlter(searchByValue)}
                    disabled={showError}
                  >
                    <div>
                      <i class="fas fa-search"></i>
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Col>
            <Col
              lg="1"
              style={{ marginTop: "9px", padding: "0px 6px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Button
                    color="light"
                    type="button"
                    style={{ width: "100%", height: "26px" }}
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => {
                      setSearchByValue("");
                      resetFilter();
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {" "}
                      <i class="fas fa-redo-alt 2px"></i> Reset
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Row>
        <div className="col card-parent">
          <Card style={{ padding: "1.25rem 1.5rem" }}>
            {dataLoading ? (
              <div style={{ textAlign: "center" }}>
                <Loading />
              </div>
            ) : (
              <>
                <NkTable
                  dataexcal
                  pagination={pagination}
                  data={allUserList}
                  rowOnClick={rowOnClick}
                  dataEXCEL={allUserListExcel}
                  buttonRef={buttonRef}
                  csvLink={csvLink}
                  onExcelClciked={() => onExcelClciked(filterForm)}
                  type="registration"
                  filterdata={filterForm}
                  columns={columns}
                  columnsCsv={columnsCsv}
                  showSizeChanged={(pageSize) => {
                    setSizeShow(pageSize);
                    setFilterForm({
                      ...filterForm,
                    });
                  }}
                  onPagechange={(page) => {
                    setFilterForm({ ...filterForm, page: page });
                  }}
                  filename={"Register-User-list"}
                />
              </>
            )}
          </Card>
        </div>
      </Row>
    </Container>
  );
};

export default RegistrationPresentational;
